import { Component } from "@angular/core";

import { BaseCvaComponent } from "./base-cva.component";

/** For use in the SSO Config Form only - will be deprecated by the Component Library */
@Component({
  selector: "app-input-checkbox",
  templateUrl: "input-checkbox.component.html",
})
export class InputCheckboxComponent extends BaseCvaComponent {}
